/* app/ui/video/hero-video */

import $ from 'jquery';
import { MediaQueries } from 'Util/mediaqueries';

var Module;
var $heroVideos;
var $heroCampignVideos;
var _videoLoaded = false;

var Module = {
	init: function () {

		$heroVideos = $('.js-hero-video') || null;
		$heroCampignVideos = $(".js-hero__campaign-video") || null;


		if ($heroVideos.length) {
			Module._initMediaQueries();
		}

		if ($heroCampignVideos.length) {
			Module._loadCampaignVideo($heroCampignVideos);

		}
	},

	_initMediaQueries: function () {

		MediaQueries.register([
			{
				queries: MediaQueries.queries['hero-large'],
				shouldDegrade: true,
				match: Module._loadVideo
				//match: function () {
				//	Module._loadVideo($heroVideos);
				//}
			}
		]);
	},

	_loadCampaignVideo: function ($videos) {
		$videos.each(function () {
			var $vid = $(this);
			var $sources = $vid.find('source');

			$sources.each(function () {
				var $source = $(this);
				var src = $source.data('src');
				if (src !== '') {
					$source.attr('src', src);
				}
			});

			this.load();
			$(this).next('.o-fit').hide();
			this.play();
		});
	},

	_loadVideo: function () {
		if (_videoLoaded) return;
		_videoLoaded = true;
		for (var i = 0; i < $heroVideos.length; i++) {
			var $vid = $heroVideos.eq(i);
			var $sources = $vid.find('source');
			for (var j = 0; j < $sources.length; j++) {
				var $source = $sources.eq(j);
				var src = $source.data('src');
				if (src !== '') {
					$source.attr('src', src);
				}
			}
			$vid[0].load();
			$vid[0].play();
		}
	}
};

var HeroVideo = {
	init: Module.init
};

$(function () {
	HeroVideo.init();
});

export { HeroVideo };